import NiceModal from '@ebay/nice-modal-react'
import dynamic from 'next/dynamic'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button, ButtonHierarchy } from '@/components/styleguide/Button'
import { constants, STATUS_LOGIN } from '@/lib/constants'
import { addToDataLayer } from '@/lib/utilities/vehicle'
import { postAnalyticsEvent } from '@/store/actions/event'
import { selectIsAuthenticated } from '@/store/selectors/user'
import { Size } from '@/types/system'
import { isProd } from '@/lib/utilities/system'

const SaveModal = dynamic(() => import('@/components/modals/SaveSearchModals/SaveModal'), {
  ssr: false,
})

const AuthenticationModal = dynamic(() => import('@/components/modals/AuthenticationModal'), {
  ssr: false,
})

export const SaveTrigger = ({ hierarchy }: { hierarchy: ButtonHierarchy }) => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(selectIsAuthenticated)

  const openSaveSearchModal = () => {
    if (isAuthenticated) {
      NiceModal.show(SaveModal as FC)
    } else {
      NiceModal.show(AuthenticationModal as FC, {
        initialStatus: STATUS_LOGIN,
      })
      addToDataLayer({
        event: 'search-filter',
        'filter-event': 'login-modal',
      })
      dispatch(
        postAnalyticsEvent({
          event: constants.eventTypes.saveSearch,
          payload: {
            authenticated: true,
          },
        }),
      )
    }
  }

  return (
    <Button
      size={Size.Medium}
      hierarchy={hierarchy}
      icon="Heart"
      onClick={openSaveSearchModal}
      label="Save search"
      className={!isProd() ? 'search__save-search-button' : ''}
    />
  )
}
